/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/react';
import { N200 } from '@atlaskit/theme/colors';
var dayNameGridStyles = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  border: 0
});
var dayNameCellStyles = css({
  boxSizing: 'border-box',
  minWidth: 40,
  padding: "var(--ds-scale-100, 8px)".concat(" ", "var(--ds-scale-100, 8px)"),
  border: 0,
  color: "var(--ds-text-subtle, ".concat(N200, ")"),
  fontSize: 11,
  fontWeight: 700,
  textAlign: 'center',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
});
var WeekHeader = /*#__PURE__*/memo(function WeekHeader(_ref) {
  var daysShort = _ref.daysShort;
  return jsx("div", {
    css: dayNameGridStyles
  }, daysShort.map(function (shortDay) {
    return jsx("span", {
      css: dayNameCellStyles,
      key: shortDay
    }, shortDay);
  }));
});
WeekHeader.displayName = 'WeekHeader'; // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default WeekHeader;